import { Color } from '@dreryk/color-common-api';
import {
   PatientGroupAlreadyExistsFault,
   PatientGroupCreateCommand,
   PatientGroupQuery,
} from '@dreryk/egabinet-patient-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

import { CustomPatientGroupsCreateFormBean } from './CustomPatientGroupsCreateForm.types';

type CustomPatientGroupsCreateActionRenderProps = {
   createCustomPatientGroup: (formData: CustomPatientGroupsCreateFormBean) => Promise<void>;
};

type CustomPatientGroupsCreateActionProps = {
   children: (renderProps: CustomPatientGroupsCreateActionRenderProps) => JSX.Element;
   onPatientGroupAlreadyExistsFault: VoidFunction;
   onSuccess: VoidFunction;
};

export const CustomPatientGroupsCreateAction = (props: CustomPatientGroupsCreateActionProps): JSX.Element => {
   const { executeAsync } = useCqrsCommand<void, CustomPatientGroupsCreateFormBean, PatientGroupAlreadyExistsFault>(
      (parameters) => {
         const command = new PatientGroupCreateCommand();
         command.name = parameters.name;
         command.primaryColor = Color.of(parameters.primaryColor);
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(translationKeys.customGroupHasBeenSaved);
            refetchCqrsQuery(PatientGroupQuery);
            props.onSuccess();
         },
         onFault: {
            'egabinet-patient-frontend-api:PatientGroupAlreadyExistsFault': props.onPatientGroupAlreadyExistsFault,
         },
      }
   );

   return props.children({ createCustomPatientGroup: executeAsync });
};
